export default "__VITE_ASSET__Cv_yJwxv__"